import {
  DataQuery
} from "cartovista";
import FeatureItem from "cartovistaExtend/panels/Results/FeatureItem";

    export default class FindRoutesFeatureItem extends FeatureItem {
      constructor(resultItem, feature, separateFeatures) {
        super(resultItem, feature, separateFeatures);
        this._styleIconCanvas = null;
      }

    _getFeatureName() {
        var name;
        var dataTable = this._resultItem._resultList.layer.getDataTable("FIND_ROUTES_DIRECTIONS");
        new DataQuery(dataTable.getDataColumns(["NAME"]), [this.feature.id])
            .execute(function(result) {
                name = result.values["FIND_ROUTES_DIRECTIONS"]["NAME"][0];
            }, this);
        return name;
    };
}
